import * as Yup from 'yup';

export const VendorPricingStatsSchema = Yup.object({
  vendor_name: Yup.string().required(),
  valid_sources: Yup.array().of(Yup.string().required()).required(),
  previous_month_count: Yup.number().required(),
  current_month_count: Yup.number().required(),
  next_month_count: Yup.number().required(),
});

export type VendorPricingStats = Yup.InferType<typeof VendorPricingStatsSchema>;

// Schema for map response from backend
export const PricingStatsMapSchema = Yup.object().test(
  'is-pricing-stats-map',
  'Invalid pricing stats map',
  (value) => {
    if (typeof value !== 'object' || value === null) {
      return false;
    }

    return Object.values(value).every((item) => {
      try {
        VendorPricingStatsSchema.validateSync(item);

        return true;
      } catch {
        return false;
      }
    });
  }
);

export type TriggerPricingUpdateRequest = {
  vendor_name: string;
  source: string;
  year?: number;
  month?: number;
};

// Helper to parse vendor/state from normalized name
export function parseVendorState(normalizedName: string): { vendor: string; state: string } {
  const parts = normalizedName.split('_');
  if (parts.length >= 2) {
    const state = parts[parts.length - 1];
    const vendor = parts.slice(0, -1).join('_');

    return { vendor, state };
  }

  return { vendor: normalizedName, state: '' };
}

// Helper to sort vendors by state first, then vendor name
export function sortVendorStats(
  statsMap: Record<string, VendorPricingStats>
): VendorPricingStats[] {
  return Object.values(statsMap).sort((a, b) => {
    const aInfo = parseVendorState(a.vendor_name);
    const bInfo = parseVendorState(b.vendor_name);

    // Sort by state first
    if (aInfo.state !== bInfo.state) {
      return aInfo.state.localeCompare(bInfo.state);
    }

    // Then by vendor name
    return aInfo.vendor.localeCompare(bInfo.vendor);
  });
}
